<template>
	<div>
		<input type="checkbox" class="mycheck" :checked="params.value" @click="checkedHandler($event)" />
	</div>
</template>

<script>
export default {
	name: "CellRendererCheckPickupUploadFile",
	computed: {
		getCheckedVisitPointsPickup() {
			return this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === undefined ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === "" ||
				this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup === null
				? []
				: this.$store.state.moduleVisitPoint.checkedUploadFileVisitPoitsPickup;
		},
	},
	methods: {
		checkedHandler(event) {
			let checked = event.target.checked;
			let colId = this.params.column.colId;
			if (this.getCheckedVisitPointsPickup.length < 2) {
				this.params.node.setDataValue(colId, checked);
				if (checked) {
					this.params.data.isPickup = true;
					this.$store.commit("moduleVisitPoint/ADD_UPLOAD_FILE_VISIT_POINT_CHECKED_PICKUP", this.params.data);
				} else {
					this.params.data.isPickup = false;
					this.$store.commit(
						"moduleVisitPoint/REMOVE_UPLOAD_FILE_VISIT_POINT_CHECKED_PICKUP",
						this.params.data
					);
				}
			} else {
				if (!checked) {
					this.params.data.isPickup = false;
					this.$store.commit(
						"moduleVisitPoint/REMOVE_UPLOAD_FILE_VISIT_POINT_CHECKED_PICKUP",
						this.params.data
					);
				} else {
					event.target.checked = false;
					this.params.node.setDataValue(colId, false);
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.mycheck {
	cursor: pointer;
	background-color: #fff;
	background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
	width: 16px;
	height: 16px;
	appearance: none;
	border: 1px solid #888;
	transition: background-color 0.3s ease-in-out;
}

.mycheck:checked {
	background-color: #420d91;
}

.mycheck:focus {
	border-color: rgb(80, 67, 250);
}

.mycheck:disabled {
	background-color: #ccc;
	background-image: none;
}

.mycheck:disabled:checked {
	background-color: #ccc;
	background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
}
</style>
